<template>
    <v-row>
        <v-col cols="12" md="12" lg="12" xl="12">
            <v-btn color="primary" class="mb-1 font-weight-bold" @click.prevent="addProduct()" :disabled="tipoEntrada == 2 || editPrice">
                <v-icon left>fas fa-plus-square</v-icon> Añadir producto ( F2 )
            </v-btn>
            <v-simple-table fixed-header class="elevation-1" dense>
                <template v-slot:default>
                    <thead class="primary">
                        <tr>
                            <th class="text-left primary font-weight-bold white--text">Producto</th>
                            <th class="text-left primary font-weight-bold white--text">Cantidad recibida</th>
                            <th class="text-left primary font-weight-bold white--text">Peso neto</th>
                            <th class="text-left primary font-weight-bold white--text">Precio</th>
                            <th class="text-left primary font-weight-bold white--text">Peso promedio</th>
                            <th class="text-left primary font-weight-bold white--text">Importe</th>
                            <th class="text-left primary font-weight-bold white--text" v-if="editPrice">Importe final</th>
                            <th class="text-left primary font-weight-bold white--text" v-if="!editPrice">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in entradaProduct" :key="item.id">
                            <td>
                                <ValidationProvider rules="required" v-slot="{ errors, valid }" :immediate="true">
                                    <v-autocomplete class="mt-5 mr-5" :items="products" item-text="nombre"
                                        item-value="id" dense filled required solo-inverted
                                        @change="(e) => changeProduct(e, index)" :value="item.productoId"
                                        :disabled="editPrice"
                                        :error-messages="errors" :success="valid">
                                        <template v-slot:item="{ item }">
                                            <div class="d-flex align-center justify-start pa-2">
                                                <strong class="mr-2 blue--text font-weight-bold">{{ item.nombre }}</strong>
                                                <span class="text--secondary font-weight-bold">{{ item.descripcion }}</span>
                                            </div>
                                        </template>

                                        <template v-slot:selection="{ attr, on, item, selected }">
                                            <v-chip v-bind="attr" :input-value="selected" color="blue darken-3"
                                                class="white--text font-weight-bold rounded" v-on="on">
                                                {{ item.nombre }} – {{ item.descripcion }}
                                            </v-chip>
                                        </template>


                                    </v-autocomplete>
                                </ValidationProvider>
                            </td>
                            <td>
                                <ValidationProvider rules="required|numeric|min_value:1" v-slot="{ errors, valid }"
                                    :immediate="true">
                                    <v-text-field v-model.number="item.cantidad" type="number" label="Cantidad"
                                        class="mt-3" outlined persistent-hint prepend-inner-icon="fas fa-boxes" required
                                        min="1" @input="(e) => changeItem(e, index, 'cantidad')"
                                        :disabled="editPrice"
                                        :error-messages="errors" :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td>
                                <ValidationProvider rules="required|decimal|min_value:0.5" v-slot="{ errors, valid }"
                                    :immediate="true">
                                    <v-text-field :value="item.netWeight" type="number" label="Peso neto" class="mt-3"
                                        outlined persistent-hint prepend-inner-icon="fas fa-weight-hanging" required
                                        min="0.5" @input="(e) => changeItem(e, index, 'netWeight')"
                                        :disabled="editPrice"
                                        :error-messages="errors" :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td>
                                <ValidationProvider
                                    :rules="tipoEntrada != 2 ? 'required|decimal|min_value:1' : 'decimal'"
                                    v-slot="{ errors, valid }" :immediate="true">
                                    <v-text-field v-model="item.precioUnitario" type="number" label="Precio"
                                        class="mt-3" outlined persistent-hint prepend-inner-icon="fas fa-dollar-sign"
                                        @input="(e) => changeItem(e, index, 'precioUnitario')"
                                        :disabled="tipoEntrada == 2 || editPrice" required min="1" :error-messages="errors"
                                        :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td>
                                <ValidationProvider rules="required|decimal|min_value:0.5" v-slot="{ errors, valid }"
                                    :immediate="true">
                                    <v-text-field v-model="item.averageWeight" type="number" label="Peso promedio"
                                        class="mt-3" outlined persistent-hint prepend-inner-icon="fas fa-weight"
                                        required min="0.5" @input="(e) => changeItem(e, index, 'averageWeight')"
                                        disabled :error-messages="errors" :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td>
                                <v-text-field :value="item.importe" type="text" label="Importe" class="mt-3" outlined
                                    persistent-hint prepend-inner-icon="fas fa-dollar-sign" disabled>
                                </v-text-field>
                            </td>
                            <td v-if="editPrice">
                                <ValidationProvider rules="required|decimal|min_value:0.5" v-slot="{ errors, valid }" :immediate="true">
                                    <v-text-field v-model="item.finalImport" type="number" label="Importe final"
                                    @input="(e) => changeFinalImport(e, index, 'finalImport')"
                                    class="mt-3" outlined persistent-hint prepend-inner-icon="fas fa-dollar-sign"
                                    :error-messages="errors" :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </td>
                            <td v-if="!editPrice">
                                <v-btn icon @click="deleteProduct(item, index)">
                                    <v-icon color="red darken-1">fas fa-trash-alt</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>
<script>
import EntradaDetalleDataService from '@/service/entrada/EntradaDetalleDataService';
import { toNumber } from '@/utils/CurrencyUtil';

export default {
    name: "addProductEntry",
    props: {
        products: { type: Array, default: () => [] },
        tipoEntrada: { type: Number, default: 1 },
        entrada: { type: Object, default: () => { } },
        mode: { type: String, default: 'add' },
        entradaId: { type: Number, default: 0 },
    },
    mounted() {
        document.addEventListener('keydown', this.addProductEntryKey);
    },
    destroyed() {
        document.removeEventListener('keydown', this.addProductEntryKey);
    },
    created() {
        // if(this.entradaId == 0){
        // this.addProduct()
        // }
    },
    beforeMount() {
        if (this.entradaId > 0) {
            this.getEntryDetail(this.entradaId);
        } else {
            this.addProduct()
        }
    },
    data() {
        return {
            entradaProduct: [],
        }
    },
    methods: {
        generateNewEntry() {
            return {
                id: null,
                entradaId: null,
                productoId: null,
                cantidad: 0,
                averageWeight: 0,
                netWeight: 0,
                precioUnitario: 0,
                importe: 0,
                finalImport: 0,
                prioridad: 1,
                merma: 0,
                existencia: 0,
                totalSalida: 0,
                totalSalidaTraspaso: 0,
                totalEntradaTraspaso: 0,
                activo: true,
                eliminado: false
            }
        },
        addProductEntryKey(e) {
            if (e.keyCode === 174) {
                this.addProduct()
            }
        },
        addProduct() {
            if (this.entradaProduct.length > 0) {
                const hasProductEmpty = this.entradaProduct.find(x => x.productoId == null);
                if (hasProductEmpty) {
                    this.$swal.fire({ position: 'top-end', icon: 'info', title: 'Ya existe una lista vacia', text: 'Debe seleccionar un producto', showConfirmButton: false, timer: 2500 });
                    return
                }
            }
            this.entradaProduct.push(this.generateNewEntry())
        },
        deleteProduct(entradaProduct, index) {
            this.enableProduct(entradaProduct.productoId, entradaProduct);
            this.entradaProduct.splice(index, 1);
        },
        enableProduct(productSelected, entradaProduct) {
            const indexProduct = this.products.findIndex(x => x.id == productSelected);
            const indexPrevProduct = this.products.findIndex(x => x.id == entradaProduct.productoId);
            if (indexProduct > -1) {
                this.products[indexProduct].disabled = true;
            }
            if (indexPrevProduct > -1) {
                this.products[indexPrevProduct].disabled = false;
            }
        },
        getEntryDetail(entradaId) {
            EntradaDetalleDataService.detailByEntradaId(entradaId).then(resp => {
                this.entradaProduct = resp.data;
                this.emitDataEntradaProduct(this.entradaProduct);
            })
        },
        changeProduct(e, index) {
            if (e != null && e > 0) {
                this.enableProduct(e, this.entradaProduct[index]);
                this.entradaProduct[index].productoId = e;
                let product = this.products.find(producto => producto.id == e);

                if (this.tipoEntrada != 2) {
                    this.entradaProduct[index].cantidad = 1;
                    this.entradaProduct[index].netWeight = 1;
                    this.entradaProduct[index].precioUnitario = this.tipoEntrada == 2 ? 0 : (product?.precioVenta || 0);
                    this.recalculateRow(index);
                }
            }
        },
        // Recalcula los importes derivados de la fila (peso promedio, importe y total final).
        recalculateRow(index) {
            const row = this.entradaProduct[index];
            if (!row) return;

            const cantidad = toNumber(row.cantidad, 0);
            const netWeight = toNumber(row.netWeight, 0);
            const precioUnitario = toNumber(row.precioUnitario, 0);

            row.averageWeight = cantidad > 0 ? parseFloat((netWeight / cantidad).toFixed(2)) : 0;

            const importe = netWeight * precioUnitario;
            row.importe = parseFloat(importe.toFixed(2));
            row.finalImport = row.importe;
        },
        changeItem(e, index, field) {
            if (e === null || e === undefined || e === '') return;
            this.entradaProduct[index][field] = e;
            this.recalculateRow(index);
        },
        changeFinalImport(e, index, field) {
            if( e != null && e > 0 ) {
                const finalImport = e
                this.entradaProduct[index][field] = finalImport;
                const netWeight = toNumber(this.entradaProduct[index].netWeight, 0);
                if (netWeight > 0) {
                    const unitPrice = finalImport / netWeight;
                    this.entradaProduct[index].precioUnitario = parseFloat(unitPrice.toFixed(2));
                }
            } 
        },
        emitDataEntradaProduct(data) {
            this.$emit('addEntradaProduct', data);
        },
        reEnableAllProducts() {
            this.products.forEach(product => product.disabled = false);
        }
    },
    watch: {
        entradaProduct: {
            handler(newVal) {
                this.emitDataEntradaProduct(newVal);
            },
            deep: true
        },
        tipoEntrada: {
            handler(newVal) {
                if (newVal == 1) {
                    this.reEnableAllProducts();
                }
            }
        },
        'entrada.sucursalRecibeId': function (newValue) {
            if (newValue != null) {
                this.reEnableAllProducts();
            }
        }
    },
    computed: {
        editDetail(){ return this.mode == 'add'; },
        editPrice(){ return this.mode == 'updatePrice'; },
    }
}
</script>